module.exports = {
      id: "ic-xrpusd-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-xrpusd-usage",
      toString: function () {
        return this.url;
      }
    }